import { createFileRoute } from '@tanstack/react-router'
import AgreementErrorReportList from 'Royalty/components/Reports/ErrorReport/AgreementErrorReportList'

export const Route = createFileRoute('/royalty/errorlist/agreements')({
    component: AgreementErrorReportList,
})
